import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { PixPayment } from "@/components/ui/pix-payment";
import { TableDataProps } from "@/pages/SalesList";
import { PIX_STATUS } from "@/utils/constants";

interface PixDialogProps {
  isOpen: boolean;
  onClose: () => void;
  sale: TableDataProps;
  onPaymentConfirmed: () => Promise<void>;
}

export function PixDialog({
  isOpen,
  onClose,
  sale,
  onPaymentConfirmed,
}: PixDialogProps) {
  if (!sale.transactions || sale.transactions.length === 0) {
    return null;
  }

  const transaction = sale.transactions[0]; // Use the first transaction
  const isPaid = transaction?.status === PIX_STATUS.PAID;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {isPaid ? "Pagamento Confirmado" : "Pagamento PIX"}
          </DialogTitle>
        </DialogHeader>
        <PixPayment
          transaction={transaction}
          saleId={sale.id}
          onPaymentConfirmed={async () => {
            await onPaymentConfirmed();
          }}
          onClose={() => {
            onClose();
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
